import React from "react";
import {
    Box,
    Skeleton,
    Text,
} from "@chakra-ui/react";
import Chart from "react-apexcharts";

const ProgrammeOverviewChart = ({
    data = {},
    isLoading,
}) => {
    const categories = [
        "Pending",
        "Approved",
        "Active",
        "Suspended",
        "Rejected",
        "Deactivated",
    ];

    const seriesData = [
        data.pending_applications ?? 0,
        data.approved_agents ?? 0,
        data.active_agents ?? 0,
        data.suspended_agents ?? 0,
        data.rejected_agents ?? 0,
        data.deactivated_agents ?? 0,
    ];

    const options = {
        chart: {
            type: "bar",
            toolbar: {
                show: false,
            },
        },
        plotOptions: {
            bar: {
                borderRadius: 4,
                columnWidth: "55%",
            },
        },
        dataLabels: {
            enabled: false,
        },
        xaxis: {
            categories,
        },
        yaxis: {
            min: 0,
            forceNiceScale: true,
        },
        grid: {
            strokeDashArray: 4,
        },
    };

    return (
        <Box
            bg="white"
            borderRadius="15px"
            p="24px"
            height="400px"
            width="100%"
            boxShadow="sm"
        >
            <Text
                color="#071D54"
                fontSize="lg"
                fontWeight="700"
                mb={4}
            >
                Agent Programme Overview
            </Text>

            {isLoading ? (
                <Skeleton
                    height="300px"
                    borderRadius="12px"
                />
            ) : (
                <Chart
                    options={options}
                    series={[
                        {
                            name: "Agents",
                            data: seriesData,
                        },
                    ]}
                    type="bar"
                    height={300}
                />
            )}
        </Box>
    );
};

export default ProgrammeOverviewChart;